import { render, staticRenderFns } from "./order.vue?vue&type=template&id=3742fba4&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3742fba4')) {
      api.createRecord('3742fba4', component.options)
    } else {
      api.reload('3742fba4', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=3742fba4&", function () {
      api.rerender('3742fba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale-nc/drop-out/components/order.vue"
export default component.exports